<template>
    <div id="fccBancos" class="fccBancos">
      <v-select   :options="listarBanco" :valorDeclarado="valorDeclarado" :value="valueInput" @input="setSelected" v-model="bancos" :placeholder="placeholder"  class="selectSPI" label="nomebanco" >
        <template #search="{attributes, events}">
            <input
            class="vs__search"
            :required="!bancos"
            v-bind="attributes"
            v-on="events"
            />
        </template>
      </v-select>
    </div>
</template>

<script>
import axios from 'axios'
import store from '@/store'
import './assets/fccBancos.scss'

export default {
  name: 'fccBancos',
  data: () => ({
    bancos: '',
    listarBanco: []
  }),
  props: {
    id: {
      type: String,
      default: null
    },
    value: {
      type: [String, Object],
      default: ''
    },
    valorDeclarado: {
      type: [String, Object],
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: 'teste'
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  computed: {
    valueInput () {
      this.$emit('changesBanco', this.bancos)
      return this.bancos
    }
  },
  methods: {
    setSelected: function () {
    },
    listandoBancos: function () {
      if (this.valorDeclarado.agencia !== '') {
        this.bancos = this.valorDeclarado
      }
      axios.get(store.state.baseUrlGestaoProjetos + 'Banco/ListaBancos', this.dadosLoginSession.fccTokenHeaders)
        .then(response => {
          this.listarBanco = response.data
        })
        .catch(this.setErrorSystem)
    }
  },
  mounted: function () {
    this.listandoBancos()
  }
}
</script>
